import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const labratorApi = createApi({
    reducerPath: "core/labrator",
    baseQuery: axiosBaseQuery,
    tagTypes: ["labratorList"],
    endpoints: (builder) =>({
        labratorFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['labratorList'],
            query: (query = '') => ({
                url: "core/labrator/" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        labratorCreate: builder.mutation({
            invalidatesTags: ['labratorList'],
            query: (data)=>({url: "core/labrator/", method: "POST", data})
        }),
        labratorUpdate: builder.mutation({
            invalidatesTags: ['labratorList'],
            query: (data)=>({url: "/core/labrator/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        labratorDelete: builder.mutation({
            invalidatesTags: ['labratorList'],
            query: (id)=>({url: "/core/labrator/"+id, method: "DELETE"})
        }),
    })
})

export const { useLabratorFindAllQuery, useLabratorCreateMutation, useLabratorUpdateMutation, useLabratorDeleteMutation } = labratorApi;
export {labratorApi};
